
import { Container, CardDeck, Row, Col, } from 'react-bootstrap';
//import 'holderjs';
import React from 'react';
import '../css/Home.css';
import HomeCard from '../components/HomeCard';
import GameCard from '../components/GameCard';
import secImg from '../img/games/spaceengineerscalculator/spaceengineerscalculatorcard.png';
import balloonImg from '../img/games/balloonkaboom/balloonkaboomcard.png';
import NewsList from '../components/NewsList';
import getItOnPlayStoreImg from '../img/getItGooglePlay.png';

function Home() {
    return <Container className="page-container px-0">
        <div className="home-banner-img">
            <h1 className="caption-title">Space Castle Games</h1>
        </div>
        <div>
            <NewsList />
            <Container className="p-3">
                <Row className="justify-content-center home-game-card-row">
                    <GameCard colsize="col-4" title="Space Engineers Calculator" description="Resource calculating tool for the game Space Engineers." imgPath={secImg} gameURL="#" playImage={getItOnPlayStoreImg} playURL="https://play.google.com/store/apps/details?id=com.spacecastlegames.spaceengineerscalculator" />
                    <GameCard colsize="col-4" title="Balloon Kaboom" description="Fun little game for kids." imgPath={balloonImg} gameURL="#" playImage={getItOnPlayStoreImg} playURL="https://play.google.com/store/apps/details?id=com.spacecastlegames.balloonkaboom.free" />
                </Row>
            </Container>

        </div >
    </Container >
}

export default Home;